import React from "react";
import numeral from "numeral";

class TaxesSelect extends React.Component {

    constructor(props) {
        super(props);
    };

    componentDidMount() {
      var self = this;
      if (self.refs.taxes) {
          $(this.refs.taxes).select2({
              multiple: true,
              ajax: {
                  url: '/admin/taxes_remote',
                  dataType: 'json',
                  delay: 250,
                  data: (params) => {
                      return {
                          q: params.term,
                          lodging: self.props.lodging ? self.props.lodging : false,
                          page: params.page,
                          results_per_page: 40,
                      };
                  },
                  processResults: (data, params) => {
                      params.page = params.page || 1;

                      return {
                          results: data.items,
                          pagination: {
                              more: (params.page * 40) < data.total_count
                          }
                      };
                  },
                  cache: false
              },
              allowClear: false,
              escapeMarkup: (markup) => {
                  return markup;
              },
            placeholder: I18n.t('select_ellipsis'),
            templateResult: (tax) => {
              if (tax.loading) {
                  return tax.text;
              }
              return this.selectedOption(tax);
            },
            templateSelection: (tax) => {
              return this.selectedOption(tax)
            }
          }).on('change', (e) => {
              let select2_data = $(self.refs.taxes).select2('data').map((tax) => {
                return tax.id
              })

              this.props.onChange(select2_data)

          })
      };
    };

    render() {
      var self = this;
      let options = this.props.taxes && this.props.taxes.length > 0 ? this.props.taxes.map((tax) => {
          return <option key={tax.id} value={tax.id} data-percentage={tax.percentage} data-amount={tax.amount}>{self.processTax(tax)}</option>
      }) : []
      let values = this.props.taxes && this.props.taxes.length > 0 ? this.props.taxes.map((tax) => { return tax.id }) : []
      return (
        <div ref="taxes_select_wrapper">
            <select defaultValue={values} multiple={true} className="form-control" ref="taxes" name={`product[taxes][]`} style={{ width: '100%', minHeight: 33 }}>
                {options}
            </select>
        </div>
      );
    };

    selectedOption(tax) {
      var self = this;
      if (tax.text) {
        return `<span key=${tax.id}>${tax.text}`
      } else {
        return `<span key=${tax.id}>${self.processTax(tax)}`
      }
    }

    processTax(tax) {
      return tax.name + `${tax.percentage ? ` ${((tax.percentage * 100).toFixed(2))}%` : this.formatCurrency(tax.amount)}`
    }

    formatCurrency(num) {
      return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
    }
}

export default TaxesSelect